import React from 'react';
import PageTitle from '../FormElements/PageTitle';
import GlobalErrorsBox from '../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import EmailInput from '../FormElements/EmailInput';
import PasswordInput from '../FormElements/PasswordInput';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';

export default class UserForm extends React.Component {
	constructor() {
		super();
		this.state = {
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			errorsList: [],
			fieldErrors: {}
		};
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	componentDidMount() {
		if (this.props.isEditing) {
			this.loadData();
		}
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('UserForm', this.props, this.state);
		return (
			<div className="w-full py-4">
				<PageTitle
					title={
						this.props.isEditing ? (
							'Update your user profile'
						) : (
							'Create your user profile'
						)
					}
				/>
				<GlobalErrorsBox globalErrors={this.state.errorsList} />
				<FormSection>
					<Label htmlFor="first_name">First Name *</Label>
					<TextInput
						id="first_name"
						name="first_name"
						value={this.state.first_name}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="last_name">Last Name *</Label>
					<TextInput
						id="last_name"
						name="last_name"
						value={this.state.last_name}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="email">Email *</Label>
					<EmailInput
						id="email"
						name="email"
						value={this.state.email}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					{this.props.isEditing ? null : (
						<div>
							<Label htmlFor="password">Password *</Label>
							<PasswordInput
								id="password"
								name="password"
								value={this.state.password}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
					)}
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end">
						<FormSubmit
							onSubmit={this.onSubmit}
							label={
								this.props.isEditing ? (
									'Save changes'
								) : (
									'Create user and continue'
								)
							}
						/>
					</div>
				</div>
				{/*	<PrimaryButton
						label="Test - Back"
						onClick={this.props.backLocation}
					/>
					<SecondaryButton
						label="Test - Continue"
						onClick={this.props.continueLocation}
					/> */}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Create user call stated...');
		// console.log('Create user call', this.props, this.state);

		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.isEditing
				? this.props.update_user_endpoint.replace('id', 1)
				: this.props.create_user_endpoint,
			dataType: 'json',
			data: {
				user: {
					first_name: this.state.first_name,
					last_name: this.state.last_name,
					email: this.state.email,
					password: this.state.password
				}
			},
			error: (response) => {
				// console.log('Create/edit user call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create user call successful.', response, status);

			if (!this.props.isEditing) {
				this.props.continueLocation(
					response.data.id,
					response.data.first_name,
					response.data.last_name,
					response.data.email
				);
			}

			if (this.props.isEditing) {
				window.location.href = `/users/1`;
			}
		});
	}

	loadData() {
		// console.log('User loadData started');
		// console.log('User loadData', this.props);

		$.ajax({
			type: 'GET',
			url: this.props.get_user_endpoint.replace('id', 1)
		}).done((payload) => {
			const result = payload;
			// console.log('User loadData done', result);
			this.setState({
				userId: result.data.id,
				first_name: result.data.first_name,
				last_name: result.data.last_name,
				email: result.data.email,
				password: result.data.password
			});
		});
	}
}
